import { type FC } from 'react';
import classnames from 'classnames';
import pageLinks from 'dibs-pagelinks';
import { type OnLinkClick } from './SharedPaginationTypes';

import { SharedPaginationItem } from './SharedPaginationItem';

import styles from './SharedPagination.scss';
import dibsCss from 'dibs-css';

type Props = {
    numberOfPages: number;
    currentPage: number;
    totalPageLinks: number;
    uriRef: string;
    onLinkClick: OnLinkClick;
    hideHref?: boolean;
};

export const SharedPaginationComponent: FC<Props> = ({
    numberOfPages,
    currentPage,
    totalPageLinks,
    uriRef,
    onLinkClick = () => {},
    hideHref,
}) => {
    if (numberOfPages <= 1) {
        return null;
    }

    const generatedPageLinks = pageLinks(numberOfPages, currentPage, totalPageLinks);

    return (
        <ul
            className={classnames(
                styles.paginationList,
                dibsCss.flex,
                dibsCss.justifyCenter,
                dibsCss.itemsCenter,
                dibsCss.mtXlarge,
                dibsCss.mbSmall,
                dibsCss.gapXsmall
            )}
            data-tp={numberOfPages}
            data-tn="pagination-list"
        >
            {generatedPageLinks.map(({ type, key, pageNumber, isSelected }) => (
                <li
                    key={key}
                    className={classnames(dibsCss.sassyFontSubHeaderTypeNormal, {
                        [styles.w48px]: type === 'page',
                        [dibsCss.relative]: ['back', 'forward'].includes(type),
                    })}
                >
                    <SharedPaginationItem
                        type={type}
                        pageNumber={pageNumber}
                        isSelected={isSelected}
                        currentPage={currentPage}
                        uriRef={uriRef}
                        onLinkClick={onLinkClick}
                        hideHref={hideHref}
                    />
                </li>
            ))}
        </ul>
    );
};
